import React from 'react';

const STATUS_CONFIG = {
  em_dia:   { label: 'Em Dia',   className: 'bg-green-100 text-green-800 border-green-200' },
  concluida:{ label: 'Concluída',className: 'bg-gray-100 text-gray-700 border-gray-200' },
  pendente: { label: 'Pendente', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  vencendo: { label: 'Vencendo', className: 'bg-yellow-100 text-yellow-800 border-yellow-300' },
  vencida:  { label: 'Vencida',  className: 'bg-red-100 text-red-800 border-red-200' },
};

export default function FeriasStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-600 border-gray-200' };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}>
      {config.label}
    </span>
  );
}
